module.exports = __webpack_public_path__ + "img/bin-svgrepo-com.f2cdcc30.svg";